import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateUserProfileInput {
	readonly birthAddress: string;
	readonly birthDate: string;
	readonly moodFrequency: string;
	readonly currentAddress: string;
	readonly firstName: string;
	readonly id: string;
	readonly lastName: string;
	readonly linkedInUrl: string;
	readonly phoneNumber: string;
	readonly timeZone: string;
}

export interface UpdateUserProfileParams {
	input: UpdateUserProfileInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserProfileApiMutation extends ApiMutation<
	UserOutput,
	UpdateUserProfileParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
			updateUserProfile(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'updateUserProfile';
}
